import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { InfoCircle } from 'react-bootstrap-icons';
import { useTranslation, Trans } from 'react-i18next';
import CookiePolicyModal from './CookiePolicyModal';
import '../css/CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const consent = document.cookie.split('; ').find(row => row.startsWith('cookieConsent='));
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // Cookie valide pour 6 mois
    document.cookie = "cookieConsent=true; max-age=15552000; path=/; SameSite=Lax";
    setShowBanner(false);
  };

  return (
    <>
      {showBanner && (
        <div className="cookie-consent-banner">
          <div className="cookie-consent-content">
            <div className="cookie-consent-text-wrapper">
              <InfoCircle size={28} className="cookie-consent-icon" />
              <p>
                <Trans i18nKey="cookie.message" components={{ bold: <strong /> }}>
                  Nous utilisons des cookies <bold>strictement nécessaires</bold> au bon fonctionnement et à la sécurité de la plateforme. Aucun cookie de suivi ou publicitaire n'est utilisé. En poursuivant votre navigation, vous acceptez l'utilisation de ces cookies.
                </Trans>
              </p>
            </div>
            <div className="cookie-consent-actions">
              <Button variant="link" onClick={() => setShowPolicy(true)} className="cookie-policy-link">
                {t('cookie.more_info', 'En savoir plus')}
              </Button>
              <Button className="cookie-accept-btn" onClick={handleAccept}>
                {t('cookie.understood', 'Compris')}
              </Button>
            </div>
          </div>
        </div>
      )}

      <CookiePolicyModal 
        show={showPolicy} 
        onHide={() => setShowPolicy(false)} 
      />
    </>
  );
};

export default CookieConsent;
